export { default, UpdateUserFn } from "./UpsertUser";



// WEBPACK FOOTER //
// ./src/mutations/UpdateUser/index.ts